/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import * as changeKeys from 'change-case/keys'
import type { CustomerApi, Customer } from '~~/layers/base/types/customer'
import { useCustomerAccsService } from '~~/layers/base/services/customerAccs.service.js'

export const useCustomerStore = defineStore('customer', () => {
    // State
    const { doFetchCustomer } = useCustomerAccsService()

    const customer = ref<Customer | null>(null)

    // ============================================================================
    // TRANSFORMATIONS
    // ============================================================================

    /**
     * Converts raw server data into client-friendly object.
     * Should be used on all data requested from server endpoints.
     * Converts all keys to camelCase.
     */
    // TODO(better-auth): when introducing an app-level user / Better Auth user model,
    // extend this mapping to attach the canonical app user id (e.g. `authUserId`)
    // so downstream code can rely on a single user identifier instead of Magento/ACCS ids.
    const deserializeUser = (data: CustomerApi | null | undefined): Customer | null => {
        if (!data) return null

        return changeKeys.camelCase(
            {
                id: data.id,
                firstName: data.firstname,
                lastName: data.lastname,
                email: data.email,
            },
            99
        ) as Customer
    }
    // Actions
    // call customer basicInfo api to test interruption
    async function getCustomer(): Promise<void> {
        try {
            const { data, error } = await doFetchCustomer()
            if (data?.value) {
                customer.value = deserializeUser(data.value)
            } else {
                throw error.value
            }
        } catch (err: any) {
            throw err
        }
    }
    return {
        // Actions
        getCustomer,
        customer,
    }
})
